import get from 'lodash/get';
import camelize from 'camelize';
import AbstractChannel from './abstract_channel';
import { NOTIFICATION_TYPES } from '../../../constants/chat';

const UPDATE_CHAT_NOTIFICATION = [
  NOTIFICATION_TYPES.PARTICIPANT_REMOVED,
  NOTIFICATION_TYPES.PARTICIPANT_ADDED,
];

export default class SystemChannel extends AbstractChannel {
  constructor(connection) {
    super();

    this._joinChannel(connection.socket, `users:${connection.userId}`);

    this.connection = connection;
  }

  _addListeners() {
    this.channel.on('users:self_info', data => this._onRecieveSelfInfo(data));

    this.channel.on('conversations:new_message', data =>
      this._onRecieveNewMessage(data),
    );
    this.channel.on('conversations:remove_messages', data =>
      this._onRecieveRemoveMessages(data),
    );
    this.channel.on('conversations:remove_chatroom', data =>
      this._onRemoveChatroom(data),
    );
    this.channel.on('conversations:remove_context_user', data =>
      this._onRemoveContextUser(data),
    );
    this.channel.on('conversations:blocked_channels', data =>
      this._onBlockChannel(data),
    );
    this.channel.on('conversations:unblocked_channels', data =>
      this._onBlockChannel(data),
    );
    this.channel.on('communities:notification', data =>
      this._onReceiveCommunitiesNotification(data),
    );
    this.channel.on('system:notification', data =>
      this._onReceiveSystemNotification(data),
    );
    this.channel.on('event:inbox_task_completed', data => {
      this._emitFormattedEvent('event:inbox_task_completed', data.data);
    });
    this.channel.on('appointsments:change_status', data => {
      this._emitFormattedEvent('appointsments:change_status', data.data);
    });
    this.channel.on('appointsments:change_room', data => {
      this._emitFormattedEvent('appointsments:change_room', data.data);
    });
    this.channel.on('appointsments:remove_from_dashboard', data => {
      this._emitFormattedEvent(
        'appointsments:remove_from_dashboard',
        data.data,
      );
    });
    this.channel.on('appointsments:pin', data => {
      this._emitFormattedEvent('appointsments:pin', data.data);
    });
    this.channel.on('appointsments:create', data => {
      this._emitFormattedEvent('appointsments:create', data.data);
    });
    this.channel.on('appointsments:update_copay', data => {
      this._emitFormattedEvent('appointsments:update_copay', data.data);
    });
    this.channel.on('appointsments:change_payment_status', data => {
      this._emitFormattedEvent(
        'appointsments:change_payment_status',
        data.data,
      );
    });
    this.channel.on('event:paya_accountvault_form_url', data => {
      this._emitFormattedEvent('event:paya_accountvault_form_url', data.data);
    });
    this.channel.on('event:paya_transaction_successful', data => {
      this._emitFormattedEvent('event:paya_transaction_successful', data.data);
    });
    this.channel.on('event:paya_transaction_declined', data => {
      this._emitFormattedEvent('event:paya_transaction_declined', data.data);
    });
    this.channel.on('phx_reply', data => {
      this._emitFormattedEvent('phx_reply', data);
    });
  }

  _onRecieveSelfInfo(data) {
    this.connection.emit('connection_ready', this);
    this._logAction('SELF DATA', get(data, 'current_entity'));

    const { teamId, teamUserId } = this.connection;

    if (teamId) {
      this.channel.push('conversations:mask', {
        tid: teamId,
        fid: teamUserId,
      });
    }
  }

  _onRecieveNewMessage(payload) {
    const data = camelize(payload);

    const message = get(data, 'message');
    const updateChat = UPDATE_CHAT_NOTIFICATION.includes(
      get(message, 'payload.data.type'),
    );
    const channel = this._getChannel(data);

    if (channel) {
      channel._onRecieveNewMessage(data);
    } else {
      this.connection.emit('new_channel_activity', data);
    }

    if (updateChat) {
      this.connection.emit('update_chat', data);
    }
  }

  _onRemoveChatroom(payload) {
    const data = camelize(payload);
    this.connection.removeChannel(data.channelId);
    this.connection.emit('remove_chatroom', data);
  }

  _onRemoveContextUser(payload) {
    const data = camelize(payload);
    this.connection.emit('remove_context_user', data);
  }

  _onRecieveRemoveMessages(payload) {
    const data = camelize(payload);
    const channel = this._getChannel(data);

    if (channel) {
      channel._onRecieveRemoveMessages(data);
    }
  }

  _getChannel(data) {
    const channelId = parseInt(get(data, 'channelId'), 10);

    return get(this.connection, ['circles', channelId]);
  }

  _onBlockChannel(payload) {
    const data = camelize(payload);

    this.connection.emit('blocked_channels', data);
  }

  _onReceiveCommunitiesNotification(payload) {
    const data = camelize(payload);
    const message = get(data, 'message');
    const notificationType = get(message, 'payload.data.type');

    this.connection.emit(notificationType, data);
  }

  _onReceiveSystemNotification(payload) {
    const data = camelize(payload);
    const error = get(data, 'data.error');
    if (error) {
      const notificationErrorCode = get(error, 'code');
      this.connection.emit(notificationErrorCode, data);
    }
  }

  _emitFormattedEvent(event, payload) {
    const data = camelize(payload);
    this.connection.emit(event, data);
  }
}



// WEBPACK FOOTER //
// ./src/utils/chatAPI/channels/system_channel.js